module.exports = __webpack_public_path__ + "static/media/Charing Cross c. 1930s.6899dbec.jpg";